




















import STextarea from '@/common/components/STextarea.vue';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import AiLoadingOverlay from '@/tasks/components/AiLoadingOverlay.vue';

export default {
  name: 'OleMissLab6ReflectionPart1',
  components: {AiLoadingOverlay, STextarea},
  mixins: [DynamicQuestionMixin()],
  props: {
    isSubmitting: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      inputs: {
        reflectionPart1: null,
      },
      questions: [
        {
          text: 'During these past three weeks, what have you learned about characterizing (identifying) an unknown material or substance?',
          inputName: 'reflectionPart1',
        },
      ],
    };
  },
};
